import request from '@/utils/request';

enum Api {
  GetDataExportCenter = '/exportCenter/list',
}

// 接口返回数据类型定义
export interface ApiResponse<T = any> {
  status: number;
  message: string;
  data: T;
  success: boolean;
}

// 导出中心列表项接口
export interface ExportCenterItem {
  fileName: string;
  fileType: string;
  dataType: string;
  dataTypeChina: string;
  size: number;
  fileStatus: string;
  createTime: string;
  filePath: string;
}

// 导出中心列表响应接口
export interface ExportCenterListResponse {
  list: ExportCenterItem[];
  total: number;
}

// 导出中心请求参数接口
export interface ExportCenterParams {
  projectId: number;
  searchValue: string;
  dataType: string;
  pageNum: number;
  pageSize: number;
}

export const GetDataExportCenter = (params: ExportCenterParams): Promise<ApiResponse<ExportCenterListResponse>> => {
  return request(Api.GetDataExportCenter, {
    method: 'GET',
    params,
  });
};
